import PropTypes from 'prop-types';

export const propTypes = {
  totalBranches: PropTypes.number.isRequired,
  countries: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  mapImage: PropTypes.string,
};
